import React from 'react';
import { Spinner } from '@increasecard/typed-components';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 112px);
  width: 100%;
`;

export function LoadingIndicator() {
  return (
    <Wrapper>
      <Spinner size={72} />
    </Wrapper>
  );
}
